import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { CircularProgress, Grid } from '@material-ui/core'
import logoBcie from '../../assets/img/logoDash.webp'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    /* backgroundImage: `url(${process.env.PUBLIC_URL + '/images/bg-cambio2-4.png'})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover', */
  },
  container: {
    position: 'absolute',
    top: '40%',
  },
}))
const Loading = () => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        className={classes.container}
      >
        <img src={logoBcie} alt="React Logo" />
        &nbsp; &nbsp;
        <CircularProgress size={45} />
      </Grid>
    </div>
  )
}

export default Loading
